module.exports = __webpack_public_path__ + "img/geboortekaart-op-maat-Lily-meisje-letterpress-roze-debossing-digitaal-drukwerk-4.c1419b32.jpg";